import { PHONE, locationSchema } from "../structured-data-core";

export function getAllenStructuredData() {
  const url = "https://restorehair.com/locations/texas/allen/";
  const description =
    "Find out about your hair transplant options in Allen with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Allen", "825 Watters Creek Blvd, Building M Suite 250", "Allen", "TX", PHONE, url, description),
  ];
}
